import type { MediaProps } from '#/lib/sanity';
import type { SanityMedia } from '#/lib/sanity/queries/media';
import { cn } from '#/lib/utils';
import { Image } from '#/components/Image';
import { VideoLoop } from '#/components/VideoLoop';

type Props = {
  media?: SanityMedia;
  loopVideo?: boolean;
} & MediaProps;

export function MediaCaption({
  className,
  caption,
}: {
  className?: string;
  caption: string;
}) {
  return (
    <figcaption
      className={cn(
        'mt-10 text-14 leading-116 text-grayscale-06 m:text-16',
        className,
      )}
    >
      {caption}
    </figcaption>
  );
}

export function Media({ media, ...rest }: Props) {
  if (!media) return null;
  if (media._type === 'image') {
    return <Image image={media} {...rest} />;
  } else if (media._type === 'videoLoop') {
    return <VideoLoop video={media} loop={rest.loopVideo} {...rest} />;
  }
}
